module.exports = __webpack_public_path__ + "img/submit_people.57a83083.png";